<template>
  <div class="downloadpage-div">
    <img class="page-headerbg" :src="bgImg" alt="" />
    <div class="page-content">
      <div class="downloadbutton-div" :style="iOSStyle" v-if="!dsf.config.setting_appdownload_ios_show || dsf.config.setting_appdownload_ios_show == 1" @click="clickIOSButton">
        <img class="typelogo" :src="iOSImg" alt="" />
        <div class="button">iOS版下载</div>
      </div>
      <div class="downloadbutton-div" :style="androidStyle" v-if="!dsf.config.setting_appdownload_android_show || dsf.config.setting_appdownload_android_show == 1" @click="clickAndroidButton">
        <img class="typelogo" :src="androidImg" alt="" />
        <div class="button">Android版下载</div>
      </div>
    </div>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfMobileDownloadPage",
  ctrlCaption: "下载页面",
  mixins: [$mixins.control],
  components: {},
  design: {
    isMask: false,
  },
  data() {
    return {
        iOSImg: require('_teas/public/img/product/downloadDefault/iOS.png'),
        iOSStyle: "",
        androidImg: require('_teas/public/img/product/downloadDefault/android.png'),
        androidStyle: "",
        bgImg: "",

    };
  },
  created() {},
  mounted() {
      if(dsf.config.setting_appdownload_ios_impression && dsf.config.setting_appdownload_ios_impression.length > 0){
        let tempColor = dsf.config.setting_appdownload_ios_impression;
        this.iOSStyle = {
          backgroundColor: tempColor,
        };
      }
      if(dsf.config.setting_appdownload_android_impression && dsf.config.setting_appdownload_android_impression.length > 0){
        let tempColor = dsf.config.setting_appdownload_android_impression;
        this.androidStyle = {
          backgroundColor: tempColor,
        };
      }
      if(dsf.config.setting_appdownload_bgpicture && dsf.config.setting_appdownload_bgpicture.length > 0){
          this.bgImg = dsf.config.setting_appdownload_bgpicture;
      }else{
          this.bgImg = require("_teas/public/img/product/downloadDefault/downloadbg.png");
      }
  },
  computed: {},
  methods: {
      clickIOSButton(){
          if(dsf.config.setting_appdownload_ios_address && dsf.config.setting_appdownload_ios_address.length > 0){
            window.location.href = dsf.config.setting_appdownload_ios_address;
          }
      },
      clickAndroidButton(){
          if(dsf.config.setting_appdownload_android_address && dsf.config.setting_appdownload_android_address.length > 0){
            window.location.href = dsf.config.setting_appdownload_android_address;
          }
      }
  },
});
</script>